"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const constants_1 = require("../../../icons/constants");
const LinkIcon_1 = require("../../../icons/LinkIcon");
const ShareIcon_1 = require("../../../icons/ShareIcon");
const IconButton_1 = require("../IconButton");
const ShareButton_module_css_1 = __importDefault(require("./ShareButton.module.css"));
const web_env_1 = require("@snapchat/web-env");
const clsx_1 = __importDefault(require("clsx"));
const copyText = (text) => {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (typeof (0, web_env_1.getWindow)() !== "undefined" && (0, web_env_1.getNavigator)()?.clipboard) {
        // eslint-disable-next-line no-restricted-globals
        void navigator.clipboard.writeText(text);
    }
    else {
        console.error("Clipboard is undefined");
    }
};
/**
 * TODO: split into a mobile and desktop share button? A bit strange to have the sharesheet
 * function being passed in from the outside, while the onclick for desktop is defined here
 */
function ShareButton({ link, isMobile, shareSheetHandler, className = "", }) {
    const handleClick = (0, react_1.useCallback)(() => {
        copyText(link);
    }, [link]);
    const onClickHandler = isMobile ? shareSheetHandler : handleClick;
    const actionMessage = isMobile ? undefined : "URL Copied!";
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, clsx_1.default)(ShareButton_module_css_1.default.icon, className), "data-testid": "spotlightShareIcon", children: (0, jsx_runtime_1.jsx)(IconButton_1.IconButton, { size: "SMALL", onClick: onClickHandler, actionMessage: actionMessage, label: "Share", children: isMobile ? (0, jsx_runtime_1.jsx)(ShareIcon_1.ShareIcon, { size: constants_1.Sizes.Large }) : (0, jsx_runtime_1.jsx)(LinkIcon_1.LinkIcon, { size: "LARGE" }) }) }));
}
exports.ShareButton = ShareButton;
//# sourceMappingURL=ShareButton.js.map